import React, { useState, useEffect } from 'react';
import { Button, Col, Container, FormGroup, Input, Row } from 'reactstrap';
// import TableService from '../../../Services/QRCodeServices/TableSerivce/TableService';
import TableService from '../../../../Services/QRCodeServices/TableSerivce/TableService';
import toast from 'react-hot-toast';


import { AddTable } from '../../table/AddTable';
// import { TableCard } from '../../table/TableCard';
import { MobileTableCard } from './MobileTableCard';
import { OrderDetailsModal } from '../../table/OrderDetailsModal';
import { TableOnClick } from '../../table/TableOnClick';

export const MobileOrgTable = ({selectedTable, setSelectedTable, tables, setTables, setTotalOrder}) => {
    // const [tables, setTables] = useState([]);
    const [activeTableDetails, setActiveTableDetails] = useState(null);
    // const [selectedTable, setSelectedTable] = useState(null);
    const [showOrderModal, setShowOrderModal] = useState(false);
    const [modal, setModal] = useState(false);
    const [tableName, setTableName] = useState('');
    const [tableDescription, setTableDescription] = useState('');
    const [loading, setLoading] = useState(false);  
    const [isOccupiedFilter, setIsOccupiedFilter] = useState('all');
    const [isActiveFilter, setIsActiveFilter] = useState('all');
    
    const [openTableOnClick, setOpenTableOnClick] = useState(false)
  
    useEffect(() => {
      fetchTables();
    }, []);
  
    // Fetch all tables for display
    const fetchTables = async () => {
      try {
        const data = await TableService.getList();
        setTables(data);
      } catch (error) {
        console.error('Error fetching tables:', error);
        toast.error('Failed to fetch tables');
      }
    };

    // Fetch active table details when an occupied table is clicked
    const fetchActiveTableDetails = async (tableId) => {
      try {
        const activeData = await TableService.getActiveTableList();
        const tableDetails = activeData.find(table => table.id === tableId);
        if (tableDetails) {
          setActiveTableDetails(tableDetails);
          setShowOrderModal(true);
        } else {
          toast.error('No active order found for this table');
        }
      } catch (error) {
        console.error('Error fetching active table details:', error);
        toast.error('Failed to fetch table details');
      }
    };
  
    const toggleModal = () => setModal(!modal);
    const toggleTableOnClickModal = () => setOpenTableOnClick(prev=> !prev)

    const handleTableClick = (table) => {
      //this is commented for test
      // if (table.isOccupied) {
      //   setSelectedTable(table);
      //   fetchActiveTableDetails(table.id);
      // }

      // setSelectedTable(table)
      // if (selectedTable && selectedTable.id === table.id) {
      //   setSelectedTable(''); // or null
      //   setOpenTableOnClick(false)
      // } else {
      //   setSelectedTable(table);
      //   setOpenTableOnClick(true)
      // }

      setSelectedTable(table);
      setOpenTableOnClick(true)

      


    };
  
    const handleCreateTable = async () => {
      setLoading(true);
      if (!tableName || !tableDescription) return;
      try {
        await TableService.create({
          identification: tableName,
          description: tableDescription,
        });
        fetchTables();
        toggleModal();
        toast.success("Table created successfully");
        setTableName('');
        setTableDescription('');
        setLoading(false);
      } catch (error) {
        console.error('Error creating table:', error);
        toast.error("Failed to create table");
        setLoading(false);
      }
    };

    const filteredTables = tables.filter((table) => {
      return (
        (isOccupiedFilter === 'all' || table.isOccupied.toString() === isOccupiedFilter) &&
        (isActiveFilter === 'all' || table.isActive.toString() === isActiveFilter)
      );
    });
  
    return (
      // <Container fluid className=" overflow-y-scroll p-0 m-0 pb-2" style={{ height: "45vh" }}>
      <Container  className=" p-0 m-0 pb-2 text-black" >


      
  
        <Row className='p-0 m-0'>
        <Col  xs={12} className=" p-0 m-0 px-3  rounded">

 {/* Horizontal Scroll Wrapper */}
            <div
                  className="d-flex flex-nowrap overflow-auto gap-4"
                  style={{ paddingBottom: '1rem', scrollSnapType: 'x mandatory' }}
                  
                >

                            {filteredTables.map((table,index) => (
                              // <Col key={table.id} xs={12} className=" p-0 m-0 mt-2 rounded bg-white">

                                <MobileTableCard 
                                  table={table} 
                                  index={index}
                                  onClick={() => handleTableClick(table)}
                                  isSelected={selectedTable?.id === table.id}
                                
                                />
                            ))}

<div className=' text-center ' style={{ minWidth: "100px", 
          maxWidth: "100px",}}>
                          <Button color="primary" className='w-100' onClick={toggleModal}>
                            + Add Table
                          </Button>
                        </div>
                         

            </div>
        
   
            </Col>
        </Row>
  
        <AddTable
          isOpen={modal}
          toggle={toggleModal}
          tableName={tableName}
          setTableName={setTableName}
          tableDescription={tableDescription}
          setTableDescription={setTableDescription}
          handleCreateTable={handleCreateTable}
        />

        {activeTableDetails && (
          <OrderDetailsModal
            isOpen={showOrderModal}
            toggle={() => {
              setShowOrderModal(false);
              setActiveTableDetails(null);
            }}
            orderDetails={activeTableDetails.menuOrder}
          />
        )}

        <TableOnClick 
          isOpen={openTableOnClick}
          toggle ={toggleTableOnClickModal}
          selectedTable={selectedTable}
          setSelectedTable={setSelectedTable}
          tables={tables}
          setTables={setTables}
          setTotalOrder={setTotalOrder}

        />




      </Container>
    );
};